/**
 * Google Ads tracking constants for web
 *
 * These constant values are set up first in the Google Ads console.
 * */

export const TRACK_WAITLIST_EMAIL_CAPTURE_GA = "AW-710646615/xaJTCOrJsPQCENe27tIC";
export const TRACK_NON_WAITLIST_EMAIL_CAPTURE_GA = "AW-710646615/MMmLCJqR8_gCENe27tIC";
export const TRACK_PURCHASE_GA = "AW-710646615/qZuICKeg2e8CENe27tIC";
